import { render, staticRenderFns } from "./Contactform.vue?vue&type=template&id=ccc01d78&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Contactform.vue"
export default component.exports